export const FETCH_CUSTOMER_REQUEST = "FETCH_CUSTOMER_REQUEST"
export const FETCH_CUSTOMER_SUCCESS = "FETCH_CUSTOMER_SUCCESS"
export const FETCH_CUSTOMER_FAILURE = "FETCH_CUSTOMER_FAILURE"